/** "Save record" — shared by the after-action report and the replay viewer's title bar. */
import { useState } from 'react';
import { bus } from '../../game/bus';
import { useT } from '../../i18n';
import { saveRecord } from '../../replay/file';
import { Button } from '../common/controls';

/**
 * The war as a `.friction-replay` download for the film archive; the label reports the outcome.
 */
export function SaveRecordButton({ variant = 'secondary' }: { variant?: 'secondary' | 'ghost' | 'ink' }) {
  const t = useT();
  const [state, setState] = useState<'idle' | 'saving' | 'saved' | 'failed'>('idle');
  const label = state === 'saved' ? t('aar.saved') : state === 'failed' ? t('aar.saveFailed') : t('aar.save');
  return (
    <Button
      variant={variant}
      icon={state === 'saved' ? 'check' : 'download'}
      disabled={state === 'saving'}
      title={t('aar.save.hint')}
      onClick={() => {
        setState('saving');
        void saveRecord().then((ok) => {
          setState(ok ? 'saved' : 'failed');
          if (ok) bus.emit('sound', { name: 'stamp' });
        });
      }}
    >
      {label}
    </Button>
  );
}
